import React from "react";

export default function PillCotizacion() {
  return <div className="pill cotizacion">Cotizacion</div>;
}
